<!-- -->
<template>
  <div class="contact-box">
    <el-form inline label-width="100px">
      <el-form-item label="所在区域">
        <el-input v-model="addParams.address"></el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="addParams.userName"></el-input>
      </el-form-item>
      <br />
      <el-form-item label="咨询内容">
        <el-input v-model="addParams.content"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="addParams.phone"></el-input>
      </el-form-item>
    </el-form>
    <div class="submit">
      <el-button @click="submitForm">提 交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addParams: {
        address: "",
        userName: "",
        content: "",
        phone: "",
      },
      addRules: {
        userName: { message: "请输入姓名" },
        content: { message: "请输入咨询内容" },
        phone: { message: "请输入联系电话" },
      },
    };
  },
  methods: {
    submitForm() {
      for (const key in this.addRules) {
        if (!this.addParams[key]) {
          this.$notify.error({ title: this.addRules[key].message });
          return;
        }
      }
      // 校验通过
      this.$api.addFeedBack(this.addParams).then((res) => {
        if (res.code == 0) {
          this.$notify.success({ title: "提交成功!" });
          Object.assign(this.$data.addParams, this.$options.data().addParams);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-box {
  background-image: url("http://gxbg.pangodso.com/file/static/contact_bg.png");
  background-size: cover;
  background-position-x: center;
  padding: 80px 0 58px;
  display: flex;
  justify-content: center;
  align-items: center;

  :deep(.el-form-item__label) {
    color: #fff;
  }
  .submit {
    margin-left: 60px;
    margin-top: -22px;
  }
}
</style>
